// $cli-hook-boot-polyfills
require('babel-polyfill');
require('custom-event-polyfill');



// WEBPACK FOOTER //
// ./resources/assets/js/boot/polyfills.js